const skills = {
  primary: [    
    {
      title: 'Java',
      rating: 4,
      path: 'java.png',
      alt: 'js',
      id: 1
    }, 
    {
      title: 'Scala',
      rating: 3,
      path: 'scala.png',
      alt: 'js',
      id: 2
    }, 
    {
      title: 'Javascript',
      rating: 4,
      path: 'js.png',
      alt: 'js',
      id: 3
    }, 
    {
      title: 'Angular Js',
      rating: 3.5,
      alt: 'Angular js',
      path: 'angularjs.jpeg',
      id: 4
    },
    {
      title: 'Angular',
      rating: 4,
      alt: 'Angular',
      path: 'angular.png',
      id: 5
    },
    {
      title: 'React Js',
      rating: 3,
      alt: 'React',
      path: 'react.png',
      id: 6
    },   
    {
      title: 'jQuery',
      rating: 3,
      alt: 'jQuery',
      path: 'jquery.png',
      id: 7
    },
    {
      title: 'GitHub Copilot',
      rating: 3,
      alt: 'jQuery',
      path: 'copilot.jpeg',
      id: 8
    },
    {
      title: 'CodeQl Autofix',
      rating: 3,
      alt: 'jQuery',
      path: 'copilot.jpeg',
      id: 9
    },
    {
      title: 'HTML5',
      rating: 4,
      path: 'html.png',
      alt: 'html',
      id: 10
    },
    {
      title: 'CSS3',
      rating: 4,
      alt: 'css3',
      path: 'css.png',
      id: 11
    },
    {
      title: 'Angular Material',
      rating: 3,
      path: 'angular_material.jpeg',
      alt: 'Angular material',
      id: 12
    },
    {
      title: 'graphQL',
      rating: 2,
      path: 'graphql.png',
      alt: 'GraphQl',
      id: 13
    }
  ],
  secondary: [  
    {
      title: 'My Sql',
      rating: 3,
      path: 'mysql.png',
      alt: 'My sql',
      id: 14
    }, 
    {
      title: 'Google Sql',
      rating: 3,
      path: 'sql.png',
      alt: 'Google sql',
      id: 15
    },  
    {
      title: 'Nest Js',
      rating: 2.5,
      path: 'nest.png',
      alt: 'Nest js',
      id: 16
    }, 
    {
      title: 'Node Js',
      rating: 2.5,
      path: 'node.png',
      alt: 'Node js',
      id: 17
    },
    {
      title: 'Mongo DB',
      rating: 2.5,
      path: 'mongo.png',
      alt: 'Mongo DB',
      id: 18
    },   
    {
      title: 'gulp',
      rating: 2,
      path: 'gulp.png',
      alt: 'Gulp',
      id: 19
    }
  ]
};

export default skills;

